// js
import React from 'react';
import PropTypes from 'prop-types';
import { chunk } from 'lodash';
import ConfiguredItemContributedCorrelationModalCategory from './ConfiguredItemContributedCorrelationModalCategory';
// css
import '../../styles/components/sources/ConfiguredItemContributedCorrelationModal.scss';


const ConfiguredItemContributedCorrelationModal = ({ open, onClose, correlationCategories }) => {
  if (!open) {
    return <div />;
  }

  const chunks = chunk(correlationCategories, Math.floor(correlationCategories.length / 2));
  return (
    <div className='configured-item-contributed-correlation-modal'>
      <div className='configured-item-contributed-correlation-modal__dialog'>
        <span
          className='configured-item-contributed-correlation-modal__close-button'
          onClick={onClose}
        />
        <div className='row'>
          {chunks.map((categories, index) => (
            <div key={index} className='col-md-6'>
              {categories.map((category, index) => (
                <ConfiguredItemContributedCorrelationModalCategory
                  key={index}
                  correlationCategory={category}
                />
              ))}
            </div>
          ))}
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <div className='configured-item-contributed-correlation-modal__notice'>
              NOTE: Correlations <span>listed in white</span> are those you marked as required.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ConfiguredItemContributedCorrelationModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  correlationCategories: PropTypes.array.isRequired
};

export default ConfiguredItemContributedCorrelationModal;



// WEBPACK FOOTER //
// ./src/components/sources/ConfiguredItemContributedCorrelationModal.js